import { useState } from 'react';

export default function useFunctionAsState(fn: any) {
  const [val, setVal] = useState(() => fn);

  function setFunc(func: () => void) {
    setVal(() => func);
  }

  return [val, setFunc];
}
